export default "__VITE_ASSET__TKhjBVyJ__"